import { lazy } from 'react';

const SchedulerGuidePublishCelebrateDialog = lazy(
  () => import('@/onboarding/modules/guides/scheduler/PublishCelebrateDialog'),
);
const SchedulerGuideWelcomeDialog = lazy(() => import('@/onboarding/modules/guides/scheduler/WelcomeDialog'));
const SchedulerGuideMagicWelcomeDialog = lazy(() => import('@/onboarding/modules/guides/scheduler/MagicWelcomeDialog'));
const SchedulerGuidePublishPreviewDialog = lazy(
  () => import('@/onboarding/modules/guides/scheduler/PublishPreviewDialog'),
);
const SchedulerGuideMagicDragCopyDialog = lazy(
  () => import('@/onboarding/modules/guides/scheduler/MagicDragCopyDialog'),
);

const SetupYourScheduleDialog = lazy(() => import('@/onboarding/dialogs/SetupYourScheduleDialog'));

// Identifiers for each dialog
export const CLEAR_SAMPLE_DATA_DIALOG = 'CLEAR_SAMPLE_DATA_DIALOG';
export const SCHEDULER_GUIDE_WELCOME_DIALOG = 'SCHEDULER_GUIDE_WELCOME_DIALOG';
export const SCHEDULER_GUIDE_MAGIC_WELCOME_DIALOG = 'SCHEDULER_GUIDE_MAGIC_WELCOME_DIALOG';
export const SCHEDULER_GUIDE_MAGIC_DRAG_COPY_DIALOG = 'SCHEDULER_GUIDE_MAGIC_DRAG_COPY_DIALOG';
export const SCHEDULER_GUIDE_PUBLISH_CELEBRATE_DIALOG = 'SCHEDULER_GUIDE_PUBLISH_CELEBRATE_DIALOG';
export const SCHEDULER_GUIDE_PUBLISH_PREVIEW_DIALOG = 'SCHEDULER_GUIDE_PUBLISH_PREVIEW_DIALOG';
export const SETUP_YOUR_SCHEDULE_DIALOG = 'SETUP_YOUR_SCHEDULE_DIALOG';

const onboardingDialogs = {
  [SCHEDULER_GUIDE_WELCOME_DIALOG]: SchedulerGuideWelcomeDialog,
  [SCHEDULER_GUIDE_MAGIC_WELCOME_DIALOG]: SchedulerGuideMagicWelcomeDialog,
  [SCHEDULER_GUIDE_MAGIC_DRAG_COPY_DIALOG]: SchedulerGuideMagicDragCopyDialog,
  [SCHEDULER_GUIDE_PUBLISH_CELEBRATE_DIALOG]: SchedulerGuidePublishCelebrateDialog,
  [SCHEDULER_GUIDE_PUBLISH_PREVIEW_DIALOG]: SchedulerGuidePublishPreviewDialog,
  [SETUP_YOUR_SCHEDULE_DIALOG]: SetupYourScheduleDialog,
};

export default onboardingDialogs;
